import { SAVE_TOKEN, DELETE_TOKEN, SAVE_USER } from "@/constants/mutations-type";
import { AUTH_TOKEN, USER_DATA } from "@/constants/storage-type";
import user from "./constants";
export default {
  [SAVE_TOKEN]: (state, payload) => {
    state.token = payload;
    localStorage.setItem(AUTH_TOKEN, payload);
  },
  [SAVE_USER]: (state, payload) => {
    state.user = payload;
    localStorage.setItem(USER_DATA,JSON.stringify(payload));
  },
  [DELETE_TOKEN]: (state) => {
    state.token = null;
    state.user = user;
    localStorage.removeItem(USER_DATA);
    localStorage.removeItem(AUTH_TOKEN);
  },
};
